module.exports = __webpack_public_path__ + "static/media/flower.9c95b175.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CareIcons/flower.svg
// module id = 607
// module chunks = 0